<template>
  <div class="qixi">
    <div @click="showDay" class="today">现在是{{now | formatDate}}</div>
    <div @click="showDay" class="today animated tada infinite delay-1s slow" v-show="isShow">距离那一天</div>
    <div @click="showDay" class="today animated tada infinite delay-1s slow" v-show="!isShow">2014年8月2日</div>
    <div @click="showDay" class="today">已经过了{{diff}}</div>
    <div class="percent">
      <div class="loading" :style="{width: loadingWidth}"></div>
      {{percent | percentCut}}%
    </div>
    <div class="btn add-per animated shake" @click="addPercent" ref="hint">
      <span>{{showHint}}</span>
    </div>
    <div class="qr animated" v-show="isHundred">
      <!-- <img src alt="QR" /> -->
      <span class="hint">{{alipayHint}}</span>
      <span id="success_form_input" class="alipay">{{alipay}}</span>
      <div
        class="btn-grey clip"
        ref="copy"
        data-clipboard-action="copy"
        data-clipboard-target="#success_form_input"
        @click="copyLink"
      >{{copy}}</div>
    </div>
  </div>
</template>

<script>
// import { clearInterval } from "timers";
const START = new Date(2014, 7, 2);
const BIRTH = new Date(1995, 5, 19, 19);

export default {
  data() {
    return {
      start: START,
      now: new Date(),
      percent: 0,
      isShow: true,
      isClicked: false,
      showHint: "点击加油",
      loadingWidth:'10%',
      isHundred: false,
      alipay: "金风玉露一相逢",
      alipayHint: "打开支付宝-红包，输入下方口令",
      copy: "点击复制",
      copyBtn: null //存储初始化复制按钮事件
    };
  },
  filters: {
    formatDate(date) {
      let year = date.getFullYear(); //存储年
      let month = date.getMonth() + 1; //存储月份
      let day = date.getDate(); //存储日期
      let hours = date.getHours(); //存储时
      let minutes = date.getMinutes(); //存储分
      let seconds = date.getSeconds(); //存储秒
      return `${year}年${month}月${day}日${hours}时${minutes}分${seconds}秒`;
    },
    percentCut(num){
      return Number(num.toString().slice(0,7));
    }
  },
  mounted() {
    let that = this;
    this.timeID = setInterval(() => {
      that.now = new Date();
    }, 1000);
    // set percent
    this.percent = (100 * (this.now - this.start)) / (this.now - BIRTH);
    this.loadingWidth = `${this.percent}%`;
    this.copyBtn = new this.clipboard(this.$refs.copy);
  },
  beforeDestroy() {
    if (this.timeID) {
      clearInterval(this.timeID);
    }
  },
  watch: {
    percent: function(val) {
      if (val > 99) {
        this.isHundred = true;
        this.showHint = "七夕快乐！";
        this.loadingWidth = `100%`;
      }
      if (this.isClicked && val !== 100) {
        this.showHint = "多点几次试试";
        this.loadingWidth = `${this.percent}%`;
      }
    }
  },
  computed: {
    diff() {
      let res = "";
      let diffSec = Math.round((this.now - this.start) / 1000);
      let day = Math.floor(diffSec / (24 * 3600));
      if (day > 0) {
        res += `${day}天`;
      } else {
        res += `0天`;
      }
      let afterDay = diffSec % (24 * 3600);
      let hour = Math.floor(afterDay / 3600);
      if (hour > 0) {
        res += `${hour}小时`;
      } else {
        res += `0小时`;
      }
      let afterHour = afterDay % 3600;
      let min = Math.floor(afterHour / 60);
      if (min > 0) {
        res += `${min}分`;
      } else {
        res += `0分`;
      }
      let afterMin = afterHour % 60;
      let sec = Math.floor(afterMin);
      if (sec > 0) {
        res += `${sec}秒`;
      } else {
        res += `0秒`;
      }
      return res;
    }
  },
  methods: {
    addPercent() {
      // let _next = this.now.getFullYear();
      // let _self = new Date();
      // let add =
      //   (_self.setFullYear(_next++) - this.start) /
      //   (_self.setFullYear(_next++) - BIRTH);
      // this.percent = 800 * add;
      this.isClicked = true;
      this.$refs.hint.classList.add('shake');
      setTimeout(() => {
        this.$refs.hint.classList.remove('shake');
      }, 2000);
      if (this.percent < 95) {
        this.percent += 5;
      } else {
        this.percent = 100;
      }
    },
    showDay() {
      this.isShow = !this.isShow;
    },
    copyLink() {
      /*这是点击按钮触发的点击事件，关于clipboard的使用就不再赘述了，上面介绍时已经讲述过，并且使用方法在官方文档上有*/
      let _this = this;
      let clipboard = _this.copyBtn;
      clipboard.on("success", function() {
        // alert('ok');
        _this.copy = '复制成功～'
      });
      clipboard.on("error", function() {
       alert('error');
      });
    }
  }
};
</script>

<style>
.qixi {
  padding-top: 10em;
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url('../assets/bg.jpeg') 100%;
}
.qixi::after{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  opacity: 0.2;
  z-index: 10;
}
.today {
  font-weight: 400;
  font-size: 18px;
  margin: 0.4em auto;
}
.last-time {
}
.percent {
  padding: 0.3em 0;
  margin: 8px 0;
  width: 80%;
  border: 1px solid #ccc;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  position: relative;
}
.loading {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: #f23fda;
  opacity: 0.4;
  border-radius: 16px;
  transition: width 100ms linear;
}
.add-per {
  margin-top: 1em;
}
.qr {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.hint {
  margin: 1em 0;
}
.alipay {
  margin-bottom: 1em;
}
.clip {
  font-size: 14px;
  font-weight: 500;
}
.btn {
  padding: 8px 24px;
  /* border: 1px solid gainsboro; */
  border-radius: 4px;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 2px;
  background: #f23fda 100%;
}
.btn-grey {
  padding: 6px 24px;
  /* border: 1px solid gainsboro; */
  border-radius: 4px;
  color: #fff;
  letter-spacing: 2px;
  background: #f23fda 100%;
}
</style>